import { IdModal } from "../../modals/IdModal";
import { createPathSelectTabInModal } from "./createPathSelectTabInModal";
export var pathOpenMarketMenu = function (action, state$, deps) { return createPathSelectTabInModal(function () { return IdModal.Market; })(action, state$, deps); };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/pathOpenMarketMenu.ts
// module id = 893
// module chunks = 3